import { render, staticRenderFns } from "./ServicesToCompleteItem.vue?vue&type=template&id=3acf2686&"
import script from "./ServicesToCompleteItem.vue?vue&type=script&lang=js&"
export * from "./ServicesToCompleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports